import { useHistory, useLocation } from "react-router-dom";

const PodcastIntegrated = ({language , token}) => {
  const history = useHistory()
  const { state } = useLocation();
  const iframePathUrl = state?.id 
  ?`/edit/${state.id}`
  :"/podcasts"
    const newPodcastIframe = "https:" +
    window.process.env.URL_Media + iframePathUrl
    +  "?lang=" + language + "&token=" +
      token +"&embedded=true"
      window.addEventListener("message", function (event) {     
        if (event && typeof event.data.info !== typeof undefined &&  typeof event.data.value !== typeof undefined ) {		
          if (event.data.info === "showPodcastStat") {
                       history.push(`/media/podcast/${event.data.value}`);                 
          }			
      }
    }); 
    return (
      <iframe
        id="iframe_podcast_display"
        src={newPodcastIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default PodcastIntegrated
